import { render, staticRenderFns } from "./AddToHome.vue?vue&type=template&id=88567558&"
import script from "./AddToHome.vue?vue&type=script&lang=js&"
export * from "./AddToHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports